import { render, staticRenderFns } from "./OW-003.vue?vue&type=template&id=bb6b6f3e&"
import script from "./OW-003.vue?vue&type=script&lang=js&"
export * from "./OW-003.vue?vue&type=script&lang=js&"
import style0 from "./OW-003.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports